import script from "./UserBillingAddresses.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBillingAddresses.vue?vue&type=script&setup=true&lang=js"

import "./style.scss?vue&type=style&index=0&id=21b230df&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b230df"]])

export default __exports__